export default __webpack_public_path__ + "static/media/Noun_Project_maintenance_icon_943595_cc.58afd109.svg";